import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "min-w-0 overflow-hidden rounded-2xl border border-[#DDE5EA] bg-gradient-to-br from-white via-white to-[#F2FBF9] shadow-[0_14px_40px_rgba(36,43,89,.08)]",
  "aria-label": "Painel visual coordenado"
}
const _hoisted_2 = { class: "flex flex-wrap items-start justify-between gap-3 border-b border-[#E8EEF0] p-5" }
const _hoisted_3 = { class: "mt-1 text-lg font-bold text-[#242B59]" }
const _hoisted_4 = { class: "rounded-full bg-[#48DDC3]/15 px-3 py-1 text-xs font-semibold text-[#168F7D]" }
const _hoisted_5 = { class: "grid min-w-0 grid-cols-1 gap-4 p-4 lg:grid-cols-2" }
const _hoisted_6 = {
  key: 0,
  class: "mx-4 mb-4 rounded-xl border border-[#BDEFE5] bg-[#F3FFFC] p-4"
}
const _hoisted_7 = { class: "mt-1 flex flex-wrap items-end justify-between gap-3" }
const _hoisted_8 = { class: "text-base font-semibold text-[#242B59]" }
const _hoisted_9 = { class: "text-xl font-bold text-[#168F7D]" }
const _hoisted_10 = {
  key: 0,
  class: "mt-3 flex flex-wrap gap-2"
}

import { computed, ref } from 'vue';
import type { AuraVisualizationPlan } from '@/types';
import { formatAuraDateLabel, formatAuraMetric } from '@/utils/auraPresentation';
import AuraChartBlock from './AuraChartBlock.vue';

interface Props {
    plan: AuraVisualizationPlan;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AuraVisualizationPanel',
  props: {
    plan: {}
  },
  setup(__props: any) {

const props = __props;
const selectedLabel = ref<string | null>(null);

const primaryChart = computed(() => props.plan.charts[0]);
const selectedIndex = computed(() => {
    if (!selectedLabel.value || !primaryChart.value?.labels) return -1;
    return primaryChart.value.labels.indexOf(selectedLabel.value);
});

const selectedDetails = computed(() => {
    const index = selectedIndex.value;
    const chart = primaryChart.value;
    if (!chart || index < 0) return null;

    const series = (chart.series || [])
        .map((item) => ({
            name: item.name,
            value: Number(item.data[index] || 0),
        }))
        .filter((item) => item.value > 0);

    return {
        label: selectedLabel.value,
        value: Number(chart.data[index] || 0),
        unit: chart.unit || '',
        series,
    };
});

const handleSelect = (params: unknown) => {
    if (!params || typeof params !== 'object' || !('name' in params)) return;
    const name = String((params as { name?: unknown }).name || '');
    selectedLabel.value = name || null;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[0] || (_cache[0] = _createElementVNode("p", { class: "text-[10px] font-bold uppercase tracking-[0.18em] text-[#168F7D]" }, " Análise coordenada ", -1)),
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.plan.title || 'Visão multidimensional'), 1)
      ]),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.plan.charts.length) + " perspectivas conectadas ", 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plan.charts, (chart, index) => {
        return (_openBlock(), _createBlock(AuraChartBlock, {
          key: chart.id || index,
          chart: chart,
          "selected-label": selectedLabel.value,
          class: _normalizeClass(['min-w-0', index === 0 ? 'lg:col-span-2' : '']),
          onSelect: handleSelect
        }, null, 8, ["chart", "selected-label", "class"]))
      }), 128))
    ]),
    (selectedDetails.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _cache[1] || (_cache[1] = _createElementVNode("p", { class: "text-[10px] font-bold uppercase tracking-[0.16em] text-[#168F7D]" }, " Foco selecionado ", -1)),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", _hoisted_8, _toDisplayString(_unref(formatAuraDateLabel)(selectedDetails.value.label)), 1),
            _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(formatAuraMetric)(selectedDetails.value.value, selectedDetails.value.unit)), 1)
          ]),
          (selectedDetails.value.series.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedDetails.value.series, (item) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: item.name,
                    class: "rounded-full bg-white px-2.5 py-1 text-xs font-medium text-[#626468]"
                  }, _toDisplayString(item.name) + ": " + _toDisplayString(_unref(formatAuraMetric)(item.value, selectedDetails.value.unit)), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})